import { UpsShipment } from '../models/ups-shipment.model';

/** One package's stored label, offered for (re)printing. */
export interface UpsPrintableLabel {
    /** Display name, e.g. "Package 1". */
    label: string;
    trackingNumber: string;
    /** Raw ZPL of this package's label, exactly as it was stored at process time. */
    labelZpl: string;
}

/**
 * The labels a shipment can print — one per package that has a stored ZPL, in package order.
 * Shared so every print surface (the office dialog, the shipping tablet) offers the same set,
 * named the same way. Nothing here talks to UPS: these labels were created when the shipment was
 * processed and are kept on the record precisely so they can be reprinted without re-calling UPS.
 */
export function upsPrintableLabels(shipment: UpsShipment | null | undefined): UpsPrintableLabel[] {
    return (shipment?.packages ?? [])
        .map((p, i) => ({ label: `Package ${i + 1}`, trackingNumber: p.trackingNumber, labelZpl: p.labelZpl }))
        .filter(l => !!l.labelZpl);
}
